/*需要请求接口的通用数据工具*/
import api_common from "../../../../api/api_sys_manage";

let nf_xzq_data = {};/*行政区数据  {'2019':[....],'2018':[....]}  */

/*处理行政区数据为树结构*/
let handle_xzq_tree_data = function(year,level = 6){
  let xzq_data = JSON.parse(JSON.stringify(nf_xzq_data[year]));
  let province_data = [];
  let city_data = [];
  let county_data = [];
  let xiang_data = [];
  let cun_data = [];

  xzq_data.forEach(item => {
    if((item.qhdm.length == 6 && item.qhdm.endsWith('0000')) ||  item.qhdm.length == 2 ){province_data.push(item)}
    if((item.qhdm.length == 6 && item.qhdm.endsWith('00')) ||  item.qhdm.length == 4 ){city_data.push(item)}
    if(item.qhdm.length == 6 && !item.qhdm.endsWith('0000') && !item.qhdm.endsWith('00') ){county_data.push(item)}
    if(item.qhdm.length == 9 ){xiang_data.push(item)}
    if(item.qhdm.length > 9 ){cun_data.push(item)}
  });

  if(level >= 12){
    xiang_data.forEach(item => {
      item.children = cun_data.filter(itemInner => {return  itemInner.sjqhdm && itemInner.sjqhdm.startsWith(item.qhdm)})
      //if(item.children){console.log('村' + item.qhdm + item.qhdm)}
      if(item.children.length == 0){item.children = ""}
      if(item.children.length > 0){item.hasChildren = true}else{item.hasChildren = false}
    })
  }

  if(level >= 9){
    county_data.forEach(item => {
      item.children = xiang_data.filter(itemInner => {return itemInner.sjqhdm && itemInner.sjqhdm.startsWith(item.qhdm)})
      //if(item.children){console.log('乡镇' + item.qhdm + item.qhdm)}
      if(item.children.length == 0){item.children = ""}
      if(item.children.length > 0){item.hasChildren = true}else{item.hasChildren = false}
    })
  }

  if(level >= 6){
    city_data.forEach(item => {
      item.children = county_data.filter(itemInner => {return itemInner.sjqhdm && itemInner.sjqhdm.startsWith(item.qhdm)})
      //if(item.children){console.log('县' + item.qhdm + item.qhdm)}
      if(item.children.length == 0){item.children = ""}
      if(item.children.length > 0){item.hasChildren = true}else{item.hasChildren = false}
    })
  }

  if(level >= 4){
    province_data.forEach(item => {
      item.children = city_data.filter(itemInner => {return itemInner.sjqhdm && itemInner.sjqhdm.startsWith(item.qhdm)})
      //if(item.children){console.log('市' + item.qhdm + item.qhdm)}
      if(item.children.length > 0){item.hasChildren = true}else{item.hasChildren = false}
    })
  }

  return province_data
};

/*获取行政区数据数组，非树结构）*/
let  get_xzq_arr_data  = function(year,copy = true){
  if(copy){return JSON.parse(JSON.stringify(nf_xzq_data[year]))}
  return nf_xzq_data[year]
};

/*获取行政区数据,树结构）*/
let  get_xzq_tree_data  = function(year,level = 6,copy = true){
  let tree_data = handle_xzq_tree_data(year,level);
  if(copy){return JSON.parse(JSON.stringify(tree_data))}
  return tree_data;
};

/**
 * 根据年份查询行政区数据
 * @param year  年份
 * @param type  tree返回树结构，其余返回数组 默认为tree
 * @param level 树结构级别，省2，市4，县6，乡9，村12 默认为6
 * @param copy  是否返回副本，默认为true
 * @returns {Promise<Promise<undefined|any|(any | void)|Promise<any>>|any|void|any>}
 */
let get_xzq_by_year = async function({nf,type = 'tree',level = 6,copy = true}){
    if(!nf){
      window.vue.GLOBAL.common_tool.warning('查询行政区数据传入年份不能为空');
      return
    }
    let year_n = nf
    let type_n = type || "tree"
    let level_n = level || 6
    let copy_n = copy || true

    if(type_n != 'tree' && nf_xzq_data[year_n]){
      return get_xzq_arr_data(year_n,copy_n)
    }

    if(type == 'tree' && nf_xzq_data[year_n]){
      return get_xzq_tree_data(year_n,level_n,copy_n)
    }

    return new Promise((resolve,reject) =>{
      query_xzq_arr_data(year_n).then(res => {
        if(type != 'tree'){
          return resolve(get_xzq_arr_data(year_n,copy_n))
        }else{
          return resolve(get_xzq_tree_data(year_n,level_n,copy_n))
        }
      }).catch(err =>{
        resolve([])
        console.error(`获取${year}年行政区数组数据异常`)
      });

    });
 }

/*根据年份请求行政区数据接口*（*/
let query_xzq_arr_data =  async function(year){
  try{
    let res = await api_common.get_xzq_by_year({nf:year});
    if(res.code == 200) {
      res.data = res.data || [];
      if (res.data.length == 0) {
        window.vue.GLOBAL.common_tool.sys_reason_log(`${year}年行政区数据返回为空`);
      }else{
        nf_xzq_data[year] = res.data
      }
    }else {
      console.error(`获取${year}年行政区数组数据返回code非0，${res.msg}`)
    }
  }catch (e) {
    console.error(`获取${year}年行政区数组数据异常`)
  }
};
export default {
  get_xzq_by_year:get_xzq_by_year,
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/api_xzq_data.js